import React, { FC, useEffect, useMemo } from 'react';
import { Loader } from 'common/components/Loader';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import {
  getTrackStoreAllStoresCollection,
  getTrackStoreLiveStoresCollection,
  getTrackStoreOnDutyCollection,
} from 'app/store/reducers/trackStore.reducer';
import { ITrackStoreStore } from 'entities/TrackStore/TrackStore.models';
import { TrackStoreStoreCard } from 'entities/TrackStore/components/TrackStoreStoreCard';
import {
  getTrackStoreLiveStoreMap,
  getTrackStoreOnDutyMap,
  getTrackStoreStoreCards,
} from 'entities/TrackStore/TrackStore.helper';

interface IComponentProps {
  store?: ITrackStoreStore;
}

export const TrackStoreStoreCards: FC<IComponentProps> = ({ store }) => {
  const dispatch = useAppDispatch();
  const {
    trackStoreAllStoresCollection,
    trackStoreAllStoresCollectionLoading,
    trackStoreOnDutyCollection,
    trackStoreOnDutyCollectionLoading,
    trackStoreLiveStoresCollection,
    trackStoreLiveStoresCollectionLoading,
  } = useAppSelector((state) => state.trackStore);
  const storeCards = useMemo(
    () => getTrackStoreStoreCards(trackStoreAllStoresCollection, store),
    [trackStoreAllStoresCollection?.data, store]
  );
  const onDutyMap = useMemo(() => getTrackStoreOnDutyMap(trackStoreOnDutyCollection), [trackStoreOnDutyCollection]);
  const liveStoresMap = useMemo(
    () => getTrackStoreLiveStoreMap(trackStoreLiveStoresCollection),
    [trackStoreLiveStoresCollection]
  );

  useEffect(() => {
    dispatch(getTrackStoreAllStoresCollection());
    dispatch(getTrackStoreOnDutyCollection({}));
    dispatch(getTrackStoreLiveStoresCollection());
  }, []);

  const loading =
    trackStoreAllStoresCollectionLoading || trackStoreOnDutyCollectionLoading || trackStoreLiveStoresCollectionLoading;

  if (loading) {
    return (
      <div className="relative ml-7 mr-7 flex__item_1" style={{ borderRadius: 20, overflow: 'hidden' }}>
        <Loader />
      </div>
    );
  }

  return (
    <div className="mb-5 relative flex__item_1">
      <div className="pl-7 pr-7 scrollbar-x track-store-store-cards-scroll">
        {storeCards.map((item) => {
          return (
            <TrackStoreStoreCard
              key={item.storeCode}
              card={item}
              onDuty={onDutyMap[item.storeCode]}
              liveStore={liveStoresMap[item.storeCode]}
            />
          );
        })}
      </div>
    </div>
  );
};
